const TEACHER_MODULE_PERMISSIONS_STORAGE_KEY = "teacher_module_permissions_v1";
export const TEACHER_MODULE_PERMISSIONS_UPDATED_EVENT = "teacher-module-permissions-updated";

const MODULE_ROUTE_PREFIXES_BY_ID = {
    1: ["/dashboard/app/attendance", "/dashboard/app/my-attendance"],
    2: ["/dashboards/app/classes", "/dashboards/app/my-classes", "/dashboards/app/my-grade"],
    3: ["/dashboard/daily-reports", "/dashboard/menu-chart", "/dashboard/accident-reports", "/dashboard/illness-reports"],
    4: ["/dashboards/app/influencer-list"],
    5: ["/dashboards/app/influencer-list"],
    6: ["/dashboard/child-registration", "/dashboard/child-registration/list"],
    8: ["/dashboards/app/my-grade"],
    10: ["/dashboards/app/classes", "/dashboards/app/my-classes", "/dashboards/app/my-grade"],
    11: ["/dashboard/accident-reports"],
    12: ["/dashboard/illness-reports"],
    13: ["/dashboard/app/medication", "/dashboard/app/non-medication"],
    14: ["/dashboard/allergy-action-plan"],
    15: ["/dashboard/menu-chart"],
    16: ["/dashboard/menu-chart"],
    17: ["/dashboard/menu-chart"],
    18: ["/dashboard/lunch-plan-waiver"],
    19: ["/dashboard/emergency-contact"],
    20: ["/dashboard/app/leave-application"],
    21: ["/dashboard/holiday"],
    22: [
        "/dashboards/app/events",
        "/dashboards/app/favorite-events",
        "/dashboards/app/my-vents",
        "/dashboards/app/my-participaion-events",
        "/dashboards/app/my-tickets"
    ],
    23: ["/dashboard/app/news-feed"],
    24: ["/dashboard/app/news-feed", "/dashboard/app/notification"],
    25: ["/dashboard/app/news-feed", "/dashboard/app/notification"],
    28: ["/dashboards/app/announcement"],
    29: ["/dashboard/app/profile", "/dashboard/app/user-profile-edit"],
    30: ["/dashboard/app/news-feed", "/dashboard/app/notification"],
    31: ["/dashboards/app/events"],
    32: ["/dashboards/app/events"],
};

const MODULE_ROUTE_PREFIXES_BY_NAME = {
    "attendance": ["/dashboard/app/attendance", "/dashboard/app/my-attendance"],
    "school dashboard": ["/dashboards/app/classes", "/dashboards/app/my-classes", "/dashboards/app/my-grade"],
    "class management": ["/dashboards/app/classes", "/dashboards/app/my-classes", "/dashboards/app/my-grade"],
    "grade management": ["/dashboards/app/my-grade"],
    "student list": ["/dashboard/child-registration", "/dashboard/child-registration/list"],
    "reports dashboard": ["/dashboard/daily-reports", "/dashboard/menu-chart", "/dashboard/accident-reports", "/dashboard/illness-reports"],
    "teachers list": ["/dashboards/app/influencer-list"],
    "non-teaching staff list": ["/dashboards/app/influencer-list"],
    "accident report": ["/dashboard/accident-reports"],
    "illness report": ["/dashboard/illness-reports"],
    "medications": ["/dashboard/app/medication", "/dashboard/app/non-medication"],
    "allergy preference": ["/dashboard/allergy-action-plan"],
    "menu management": ["/dashboard/menu-chart"],
    "menu types": ["/dashboard/menu-chart"],
    "meal calendar": ["/dashboard/menu-chart"],
    "lunch plan waiver": ["/dashboard/lunch-plan-waiver"],
    "emergency contact": ["/dashboard/emergency-contact"],
    "event management": [
        "/dashboards/app/events",
        "/dashboards/app/favorite-events",
        "/dashboards/app/my-vents",
        "/dashboards/app/my-participaion-events",
        "/dashboards/app/my-tickets"
    ],
    "user posts": ["/dashboard/app/news-feed"],
    "objectionable posts": ["/dashboard/app/news-feed", "/dashboard/app/notification"],
    "user post comments": ["/dashboard/app/news-feed", "/dashboard/app/notification"],
    "objectionable words": ["/dashboard/app/news-feed", "/dashboard/app/notification"],
    "public announcement": ["/dashboards/app/announcement"],
    "holiday list": ["/dashboard/holiday"],
    "leave applications": ["/dashboard/app/leave-application"],
    "general settings": ["/dashboard/app/profile", "/dashboard/app/user-profile-edit"],
};

const ALWAYS_ALLOWED_PREFIXES = [
    "/",
    "/about-us",
    "/contact-us",
    "/privacy-policy",
    "/terms-of-use",
    "/auth",
    "/chat",
    "/dashboard/blog",
];

function normalizePermissionData(permissionData = null) {
    if (!permissionData || typeof permissionData !== "object") {
        return null;
    }

    if (Array.isArray(permissionData.modules)) {
        return permissionData;
    }

    if (!Array.isArray(permissionData.roles)) {
        return permissionData;
    }

    const flattenedModules = [];
    const seenModuleIds = new Set();

    permissionData.roles.forEach((roleData) => {
        const roleModules = Array.isArray(roleData?.modules) ? roleData.modules : [];

        roleModules.forEach((moduleData) => {
            const moduleId = moduleData?.module_id;

            if (moduleId !== undefined && moduleId !== null) {
                if (seenModuleIds.has(moduleId)) {
                    return;
                }
                seenModuleIds.add(moduleId);
            }

            flattenedModules.push(moduleData);
        });
    });

    return {
        ...permissionData,
        modules: flattenedModules,
    };
}

function getPermissionModules(permissionData = null) {
    const normalizedPermissionData = normalizePermissionData(permissionData);
    return Array.isArray(normalizedPermissionData?.modules)
        ? normalizedPermissionData.modules
        : [];
}

export function isTeacherLoginProfile(profileData) {
    const classAvailabilityFlag = process.env.REACT_APP_IS_CLASS_AVAILABLE;
    const classAvailable =
        classAvailabilityFlag === undefined || classAvailabilityFlag === null || classAvailabilityFlag === ""
            ? true
            : classAvailabilityFlag === 1 || classAvailabilityFlag === "1";
    const isInfluencerTeacher = Number(profileData?.user_setting?.is_influencer) === 1;
    const isDanceCornerTeacher = Number(profileData?.user_setting?.is_dance_corner) === 1;

    return classAvailable && (isInfluencerTeacher || isDanceCornerTeacher);
}

function emitTeacherPermissionUpdate() {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent(TEACHER_MODULE_PERMISSIONS_UPDATED_EVENT));
}

export function normalizePath(path = "") {
    if (!path || typeof path !== "string") {
        return "";
    }

    if (path.startsWith("http://") || path.startsWith("https://")) {
        try {
            const parsed = new URL(path);
            path = parsed.pathname;
        } catch (error) {
            return "";
        }
    }

    if (path.startsWith("#")) {
        return "#";
    }

    const queryStart = path.indexOf("?");
    const hashStart = path.indexOf("#");
    let endIndex = path.length;

    if (queryStart >= 0) {
        endIndex = queryStart;
    }

    if (hashStart >= 0 && hashStart < endIndex) {
        endIndex = hashStart;
    }

    const cleanedPath = path.slice(0, endIndex);

    if (!cleanedPath) {
        return "/";
    }

    return cleanedPath.endsWith("/") && cleanedPath !== "/"
        ? cleanedPath.slice(0, -1)
        : cleanedPath;
}

export function setStoredTeacherModulePermissionData(permissionData) {
    if (!permissionData) {
        localStorage.removeItem(TEACHER_MODULE_PERMISSIONS_STORAGE_KEY);
        return;
    }

    const normalizedPermissionData = normalizePermissionData(permissionData);

    localStorage.setItem(
        TEACHER_MODULE_PERMISSIONS_STORAGE_KEY,
        JSON.stringify(normalizedPermissionData)
    );

    emitTeacherPermissionUpdate();
}

export function getStoredTeacherModulePermissionData() {
    try {
        const rawData = localStorage.getItem(TEACHER_MODULE_PERMISSIONS_STORAGE_KEY);
        if (!rawData) {
            return null;
        }

        return normalizePermissionData(JSON.parse(rawData));
    } catch (error) {
        localStorage.removeItem(TEACHER_MODULE_PERMISSIONS_STORAGE_KEY);
        return null;
    }
}

export function clearStoredTeacherModulePermissionData() {
    localStorage.removeItem(TEACHER_MODULE_PERMISSIONS_STORAGE_KEY);
    emitTeacherPermissionUpdate();
}

function getModuleRoutePrefixes(moduleData = {}) {
    if (!moduleData) {
        return [];
    }

    const fromId = MODULE_ROUTE_PREFIXES_BY_ID[moduleData.module_id] || [];
    const moduleNameKey = (moduleData.module_name || "").trim().toLowerCase();
    const fromName = MODULE_ROUTE_PREFIXES_BY_NAME[moduleNameKey] || [];

    const allPrefixes = [...fromId, ...fromName]
        .map((prefix) => normalizePath(prefix))
        .filter(Boolean);

    return Array.from(new Set(allPrefixes));
}

function getAllowedPathPrefixes(permissionData) {
    const modules = getPermissionModules(permissionData);
    const allowedPrefixes = new Set();

    modules.forEach((moduleData) => {
        const canView = moduleData?.permissions?.is_view === true;
        if (!canView) {
            return;
        }

        const routePrefixes = getModuleRoutePrefixes(moduleData);
        routePrefixes.forEach((prefix) => allowedPrefixes.add(prefix));
    });

    return Array.from(allowedPrefixes);
}

function getKnownRestrictedPrefixes() {
    const allKnownRestrictedPrefixes = new Set();

    Object.values(MODULE_ROUTE_PREFIXES_BY_ID).forEach((prefixes) => {
        prefixes.forEach((prefix) => allKnownRestrictedPrefixes.add(normalizePath(prefix)));
    });

    Object.values(MODULE_ROUTE_PREFIXES_BY_NAME).forEach((prefixes) => {
        prefixes.forEach((prefix) => allKnownRestrictedPrefixes.add(normalizePath(prefix)));
    });

    return Array.from(allKnownRestrictedPrefixes).filter(Boolean);
}

export function isTeacherUser(profileData, permissionData = null) {
    return isTeacherLoginProfile(profileData);
}

export function canTeacherAccessPath(path, profileData, permissionData = null) {
    const normalizedPath = normalizePath(path);

    if (!normalizedPath || normalizedPath === "#") {
        return true;
    }

    const effectivePermissionData = normalizePermissionData(permissionData || getStoredTeacherModulePermissionData());
    const teacherUser = isTeacherUser(profileData, effectivePermissionData);

    if (!teacherUser) {
        return true;
    }

    const allKnownRestrictedPrefixes = getKnownRestrictedPrefixes();
    const matchingRestrictedPrefixes = allKnownRestrictedPrefixes.filter(
        (prefix) => prefix && normalizedPath.startsWith(prefix)
    );

    if (!effectivePermissionData || getPermissionModules(effectivePermissionData).length === 0) {
        return matchingRestrictedPrefixes.length === 0;
    }

    const alwaysAllowed = ALWAYS_ALLOWED_PREFIXES.some((allowedPrefix) => {
        if (allowedPrefix === "/") {
            return normalizedPath === "/";
        }
        return normalizedPath.startsWith(allowedPrefix);
    });

    if (alwaysAllowed) {
        return true;
    }

    if (matchingRestrictedPrefixes.length === 0) {
        return true;
    }

    const allowedPrefixes = getAllowedPathPrefixes(effectivePermissionData);
    return matchingRestrictedPrefixes.some((prefix) => allowedPrefixes.includes(prefix));
}

export function getTeacherPermissionFallbackPath(permissionData = null) {
    const effectivePermissionData = normalizePermissionData(permissionData || getStoredTeacherModulePermissionData());
    const modules = getPermissionModules(effectivePermissionData);

    if (!effectivePermissionData || modules.length === 0) {
        return "/";
    }

    for (const moduleData of modules) {
        if (moduleData?.permissions?.is_view !== true) {
            continue;
        }

        const routePrefixes = getModuleRoutePrefixes(moduleData);
        if (routePrefixes.length > 0) {
            return routePrefixes[0];
        }
    }

    return "/";
}
